import React from "react";

import { IgLoading, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

interface ProductsLoadingPleaseWaitProps {
  loadingCount?: number;
  totalProducts?: number;
}

export const ProductsLoadingPleaseWait = ({
  loadingCount,
  totalProducts,
}: ProductsLoadingPleaseWaitProps) => {
  return (
    <Grid
      container
      item
      sx={{ flexGrow: 0 }}
      alignItems={"center"}
      justifyContent={"center"}
      direction={"column"}
    >
      <Grid item>
        <IgLoading />
      </Grid>
      <Grid item>
        {totalProducts && loadingCount ? (
          <IgTypography>
            Loading {loadingCount} / {totalProducts} Products...
          </IgTypography>
        ) : (
          <IgTypography>Loading Products...</IgTypography>
        )}
      </Grid>
    </Grid>
  );
};
